"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceFromKey = exports.BookSide = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
const layout_1 = require("./layout");
const utils_1 = require("./utils/utils");
const client_1 = require("./client");
// TODO - maybe store ref inside PerpMarket class
class BookSide {
    constructor(publicKey, perpMarket, decoded) {
        this.publicKey = publicKey;
        this.isBids = decoded.metaData.dataType === layout_1.DataType.Bids;
        this.perpMarket = perpMarket;
        Object.assign(this, decoded);
    }
    *items() {
        if (this.leafCount === 0) {
            return;
        }
        const now = new bn_js_1.default(client_1.getUnixTs());
        const stack = [this.rootNode];
        const [left, right] = this.isBids ? [1, 0] : [0, 1];
        const side = (this.isBids ? 'buy' : 'sell');
        while (stack.length > 0) {
            const index = stack.pop();
            // @ts-ignore
            const { leafNode, innerNode } = this.nodes[index]; // we know index is not undefined
            if (leafNode) {
                const price = getPriceFromKey(leafNode.key);
                const expiryTimestamp = leafNode.timeInForce
                    ? leafNode.timestamp.add(new bn_js_1.default(leafNode.timeInForce))
                    : utils_1.U64_MAX_BN;
                if (now.lt(expiryTimestamp)) {
                    yield {
                        orderId: leafNode.key,
                        clientId: leafNode.clientOrderId,
                        owner: leafNode.owner,
                        openOrdersSlot: leafNode.ownerSlot,
                        feeTier: 0,
                        price: this.perpMarket.priceLotsToNumber(price),
                        priceLots: price,
                        size: this.perpMarket.baseLotsToNumber(leafNode.quantity),
                        sizeLots: leafNode.quantity,
                        side,
                        bestInitial: leafNode.bestInitial,
                        timestamp: leafNode.timestamp,
                        expiryTimestamp,
                    };
                }
            }
            else if (innerNode) {
                stack.push(innerNode.children[right], innerNode.children[left]);
            }
        }
    }
    /**
     * Return the ui price reached at `quantity` lots up the book;
     * return undefined if `quantity` not on book
     */
    getImpactPriceUi(quantity) {
        const s = utils_1.ZERO_BN.clone();
        for (const order of this) {
            s.iadd(order.sizeLots);
            if (s.gte(quantity)) {
                return order.price;
            }
        }
        return undefined;
    }
    getBest() {
        if (this.leafCount === 0) {
            return;
        }
        const [left, right] = this.isBids ? [1, 0] : [0, 1];
        const side = (this.isBids ? 'buy' : 'sell');
        const stack = [this.rootNode];
        const now = new bn_js_1.default(client_1.getUnixTs());
        while (stack.length > 0) {
            let index = stack.pop();
            // @ts-ignore
            const { leafNode, innerNode } = this.nodes[index]; // we know index is not undefined
            if (leafNode) {
                const price = getPriceFromKey(leafNode.key);
                const expiryTimestamp = leafNode.timeInForce
                    ? leafNode.timestamp.add(new bn_js_1.default(leafNode.timeInForce))
                    : utils_1.U64_MAX_BN;
                if (now.lt(expiryTimestamp)) {
                    return {
                        orderId: leafNode.key,
                        clientId: leafNode.clientOrderId,
                        owner: leafNode.owner,
                        openOrdersSlot: leafNode.ownerSlot,
                        feeTier: 0,
                        price: this.perpMarket.priceLotsToNumber(price),
                        priceLots: price,
                        size: this.perpMarket.baseLotsToNumber(leafNode.quantity),
                        sizeLots: leafNode.quantity,
                        side,
                        bestInitial: leafNode.bestInitial,
                        timestamp: leafNode.timestamp,
                        expiryTimestamp,
                    };
                }
            }
            else if (innerNode) {
                stack.push(innerNode.children[right], innerNode.children[left]);
            }
        }
    }
    [Symbol.iterator]() {
        return this.items();
    }
    getL2Ui(depth) {
        const levels = []; // (price, size)
        //@ts-ignore
        for (const { price, size } of this.items()) {
            if (levels.length > 0 && levels[levels.length - 1][0] === price) {
                levels[levels.length - 1][1] += size;
            }
            else if (levels.length === depth) {
                break;
            }
            else {
                levels.push([price, size]);
            }
        }
        return levels;
    }
    getL2(depth) {
        const levels = []; // (price, size)
        //@ts-ignore
        for (const { priceLots, sizeLots } of this.items()) {
            if (levels.length > 0 && levels[levels.length - 1][0].eq(priceLots)) {
                levels[levels.length - 1][1].iadd(sizeLots);
            }
            else if (levels.length === depth) {
                break;
            }
            else {
                levels.push([priceLots, sizeLots]);
            }
        }
        return levels.map(([priceLots, sizeLots]) => [
            this.perpMarket.priceLotsToNumber(priceLots),
            this.perpMarket.baseLotsToNumber(sizeLots),
            priceLots,
            sizeLots,
        ]);
    }
}
exports.BookSide = BookSide;
function getPriceFromKey(key) {
    return key.ushrn(64); // TODO - maybe use shrn instead
}
exports.getPriceFromKey = getPriceFromKey;
//# sourceMappingURL=book.js.map